

import zipTools from 'components/zip-tools';
import cookies from 'utils/cookies';
import zip from 'lib/util/zip';
  // TODO: while this is better than lib/tda/www.js, it's still pretty crummy
  // PLUS, we still do lib/tda/www.js things on DOM ready (see main.header.js)
  export default function wwwClickEvent(target) {
    var $target = $(target);
    var redirect = $target.attr('href');

    $target.on('click', function (e) {
      e.preventDefault();
      cookies.removeItem('geoIgnore', '/', cookies.getCrossDomainCookieDomain());
      window.zipTools.redirectPath = redirect;
      // Already confirmed zip is unlikely, but possible. User hit back button for example
      if (cookies.getItem('isConfirmedZip') === 'true') {
        zipTools.setInitialZipAndTransfer(zip.getCookiedDefaultFallback());
      } else {
        zipTools.detectZip();
      }
    });
  };

